// extracted by mini-css-extract-plugin
export default {"VoidText":"index__VoidText__JFREc"};